/**
*
* FeaturedGoods
*
*/

import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { GOOD_OFFERS, NOTIFY_STOCK } from 'components/Popup/constants';

import { makeSelectIsDealerDomain, makeSelectCurrentDomain, makeSelectFavs } from 'containers/App/selectors';
import { makeSelectEntities } from 'models/selectors';

import { setPopup, favToggle } from 'containers/App/actions';

import DisplayContainer from 'components/DisplayContainer';
import Good from 'components/Good';
import DealerGood from 'components/Good/DealerGood';
import Filter from 'components/Filter';
import * as metricsActions from 'containers/App/metricsActions'

class FeaturedGoods extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  componentDidMount () {
    const { filtersSubmit, isDealerDomain } = this.props;
    filtersSubmit(isDealerDomain ? { dealerStatus: true, dealerFeatured: true } : { status: true, featured: true });
  }

  render () {
    const {
      filterStatus, ids, goods, getRecords, images, setPopup, isDealerDomain, dealerGoods, domain, favToggle, favs, compares, offers, sendRaw
    } = this.props;
    const records = getRecords(ids, goods);
    const Template = isDealerDomain ? DealerGood : Good;
    return (
      <div>
        <h3>
          Аксессуары
        </h3>
        <DisplayContainer
          records={records}
          loading={filterStatus && filterStatus.fetching && !filterStatus.initial}
          showInitial={filterStatus && filterStatus.initial}
          empty="Нет записей"
          images={images}
          Template={Template}
          containerClassName="goods"
          setPopup={(opts) => { setPopup(GOOD_OFFERS, opts); }}
          setPopupNotify={(opts) => { setPopup(NOTIFY_STOCK, opts); }}
          templateProps={{
            sendRaw, dealerGoods, dealerId: domain && domain.dealerId, favToggle, favs, compares, singleDealerDomain: domain && domain.dealers && !domain.dealers.length, offers: offers
          }}
        />

        <Link onClick={() => sendRaw('PartsPage', 'click_show_all')} to="/accessories" className="acc-link">
          Все аксессуары &nbsp;
          <FontAwesomeIcon className="green" icon={faChevronRight} />
        </Link>

      </div>

    );
  }
}

FeaturedGoods.propTypes = {

};

const mapStateToProps = createStructuredSelector({
  goods: makeSelectEntities('goods'),
  images: makeSelectEntities('images'),
  dealerGoods: makeSelectEntities('dealerGoods'),
  isDealerDomain: makeSelectIsDealerDomain(),
  domain: makeSelectCurrentDomain(),
  offers: makeSelectEntities('offers'),
  favs: makeSelectFavs(),
  compares: makeSelectFavs(1),
});

function mapDispatchToProps (dispatch) {
  return {
    setPopup: (id, opts) => dispatch(setPopup(id, opts)),
    favToggle: (payload) => dispatch(favToggle(payload)),
    sendRaw: (c, a, l) => dispatch(metricsActions.sendRaw(c, a, l))
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withFilter = Filter({
  name: 'accessories-home', model: 'goods', perPage: 30, initialQuery: false,
});

export default compose(
  withConnect,
  withFilter,
)(FeaturedGoods);
